import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from "rxjs/operators";
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { FichaResponse } from 'src/app/modal/ficha/ficha-response';
import { VisorResponse } from 'src/app/modal/visor/visor-response';

@Injectable({
  providedIn: 'root'
})
export class FichaService {

  constructor(private httpClient: HttpClient) { }

  obtenerDocumentalID(idDocumento: String) {
    let url = `${environment.urlBase}${environment.documentoXID}?idDocumento=${idDocumento}`;

    return this.httpClient.get<FichaResponse>(url).pipe(
      map(data => {
        let response: FichaResponse;
        response = data;
        return response;
      },
        error => {
          return new Response("9999", error);
        }))
  }
  documentalRelacionado(idDocumento: String) {
    let url = `${environment.urlBase}${environment.documentalRelacionado}?idDocumento=${idDocumento}`;

    return this.httpClient.get<FichaResponse>(url).pipe(
      map(data => {
        let response: FichaResponse;
        response = data;
        return response;
      },
        error => {
          return new Response("9999", error);
        }))
  }

  obtenerDatosVisor(idDocumento: String) {
    let url = `${environment.urlBase}${environment.obtenerDatosVisor}?idDocumento=${idDocumento}`;

    return this.httpClient.get<VisorResponse>(url).pipe(
      map(data => {
        let response: VisorResponse;
        response = data;
        return response;
      },
        error => {
          return new Response("9999", error);
        }))
  }


}
